import { moduleDescriptionLenses } from 'root/src/client/logic/route/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewModuleType } = moduleDescriptionLenses

export default (state, { moduleId }) =>	viewModuleType(moduleId, moduleDescriptions)
